// ============================================
// FAMUZA MARKET — Reset Password Page
// Handles password reset from email link
// ============================================

import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { useNavigate, Link } from 'react-router-dom';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase automatically handles the token from the URL
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        // User is in password recovery mode — good to go
        console.log('Password recovery mode active');
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  async function handleReset(e) {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) { setError('Passwords do not match.'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }

    setLoading(true);

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setSuccess(true);
      setTimeout(() => navigate('/seller/dashboard'), 2000);
    }
  }

  if (success) {
    return (
      <div style={{ background: '#0D0D0D', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
        <div style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.75rem', fontWeight: 800, color: '#F5F0E8', marginBottom: '0.75rem' }}>Password Updated!</h2>
          <p style={{ fontSize: '0.95rem', color: 'rgba(245,240,232,0.6)', lineHeight: 1.7 }}>
            Your password has been changed successfully. Redirecting to your dashboard...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: '#0D0D0D', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ maxWidth: 420, width: '100%' }}>

        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.5rem', fontWeight: 800, color: '#F5F0E8', marginBottom: '0.25rem' }}>
              FAMUZA <span style={{ color: '#E8622A' }}>Market</span>
            </div>
          </Link>
          <div style={{ fontSize: '0.82rem', color: 'rgba(245,240,232,0.4)' }}>Set your new password</div>
        </div>

        <div style={{ background: '#161616', border: '0.5px solid rgba(255,255,255,0.07)', borderRadius: 18, padding: '2rem' }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.1rem', fontWeight: 700, color: '#F5F0E8', marginBottom: '1.5rem' }}>
            🔐 Reset Password
          </h2>

          <form onSubmit={handleReset}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', color: 'rgba(245,240,232,0.6)', marginBottom: '0.4rem' }}>New Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Minimum 6 characters"
                style={{ width: '100%', padding: '0.75rem 1rem', background: '#0D0D0D', border: '0.5px solid rgba(255,255,255,0.1)', borderRadius: 10, color: '#F5F0E8', fontSize: '0.9rem', fontFamily: 'DM Sans, sans-serif', outline: 'none', boxSizing: 'border-box' }} />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', color: 'rgba(245,240,232,0.6)', marginBottom: '0.4rem' }}>Confirm New Password</label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required placeholder="Repeat your password"
                style={{ width: '100%', padding: '0.75rem 1rem', background: '#0D0D0D', border: `0.5px solid ${confirmPassword && confirmPassword !== password ? 'rgba(232,98,42,0.6)' : confirmPassword && confirmPassword === password ? 'rgba(37,211,102,0.6)' : 'rgba(255,255,255,0.1)'}`, borderRadius: 10, color: '#F5F0E8', fontSize: '0.9rem', fontFamily: 'DM Sans, sans-serif', outline: 'none', boxSizing: 'border-box' }} />
              {confirmPassword && confirmPassword !== password && <div style={{ fontSize: '0.75rem', color: '#E8622A', marginTop: '0.3rem' }}>Passwords don't match</div>}
              {confirmPassword && confirmPassword === password && <div style={{ fontSize: '0.75rem', color: '#25D366', marginTop: '0.3rem' }}>✓ Passwords match</div>}
            </div>

            {error && (
              <div style={{ background: 'rgba(232,98,42,0.1)', border: '0.5px solid rgba(232,98,42,0.3)', borderRadius: 8, padding: '0.75rem', fontSize: '0.82rem', color: '#E8622A', marginBottom: '1rem' }}>
                ⚠️ {error}
              </div>
            )}

            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: '0.9rem', background: loading ? '#333' : '#E8622A', color: '#fff', border: 'none', borderRadius: 12, fontSize: '1rem', fontFamily: 'DM Sans, sans-serif', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Updating...' : 'Set New Password'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <Link to="/seller/auth" style={{ fontSize: '0.82rem', color: 'rgba(245,240,232,0.4)', textDecoration: 'none' }}>← Back to Login</Link>
        </div>
      </div>
    </div>
  );
}
